import React from "react";
import { chargeStatus } from "../../../utils/chargeStatus";

/**
 * A small status label on a charge: Draft / Due / Paid / Partially paid /
 * Canceled / Payment plan. Renders nothing for a payment line.
 */
const ChargeStatusBadge: React.FC<{ invoice: any; isDarkMode?: boolean }> = ({ invoice, isDarkMode = false }) => {
  const status = chargeStatus(invoice, isDarkMode);
  if (!status) return null;
  return (
    <span
      data-testid="charge-status"
      title={status.title}
      className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap flex-shrink-0 ${status.className}`}
    >
      {status.label}
    </span>
  );
};

export default ChargeStatusBadge;
